import { push } from 'redux-first-history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ProximityCard } from '@imprivata/nucleus';
import LogoutStyled from '../shared/LogoutStyled';
import * as actions from '../../actions';
import MoreOptions from '../shared/MoreOptions';

/**
 * ProxCard Component
 * Proximity card authentication - waits for badge tap
 */
export class ProxCard extends Component {
  /**
   * The allowed properties for the ProxCard component
   * @param {array} availableModalities available modalities to switch to
   * @param {bool} useCustomUX Use Parkland custom UX
   */

  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    useCustomUX: PropTypes.bool,
  };

  static defaultProps = {
    availableModalities: [],
    useCustomUX: false,
  };

  // Note: Subscription lifecycle is managed at the session level (startProxDeviceWatch in startSession.js)
  // This component just renders UI - subscription is already active when this mounts
  // We do NOT unsubscribe on unmount because reader disconnect monitoring must continue
  // even when user switches to other modalities (REQ-010)

  render() {
    const { availableModalities, useCustomUX, } = this.props;

    let moreOptions = null;
    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'proxcard' && e !== 'tempcode') : [];
    const modalitiesArePresent = modalities.length > 0;

    if (modalitiesArePresent) {
      moreOptions = <MoreOptions currentModality='proxcard' />;
    }

    const logoutStyle = useCustomUX ? 'black' : 'white';
    const logoutComponent = <LogoutStyled type={logoutStyle} />;

    return (
      <div data-automation-id='proxCardPage' className='Prox-card-page'>
        <ProximityCard
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          moreOptionsLink={moreOptions}
          logout={logoutComponent}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { availableModalities, useCustomUX, } = state.login;

  return {
    availableModalities,
    useCustomUX,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProxCard);
